import type {CSSProperties} from 'react';

/** Shared openModal props for tall compose dialogs (newsletter / registration mail). */
export const largeEditorModalProps = {
    size: '85vw' as const,
    styles: {
        content: {
            maxHeight: '90dvh',
            display: 'flex',
            flexDirection: 'column',
        } satisfies CSSProperties,
        body: {
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            paddingBottom: 'max(var(--mantine-spacing-md), env(safe-area-inset-bottom))',
        } satisfies CSSProperties,
    },
};

/** Scrollable region above a fixed action bar inside a large editor modal. */
export const largeEditorModalScrollAreaStyle: CSSProperties = {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
};

/** Outer stack that fills the modal body (scroll area + sticky actions). */
export const largeEditorModalBodyStyle: CSSProperties = {
    flex: 1,
    minHeight: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
};
